import React from 'react';
import i18n from '../../../i18n';
import { MzadLoader } from '../../helpers/mzadLoader';
import { getAllOfficers } from '../../../models/officers';
import swal from 'sweetalert';
import { createMeetingAttendees } from '../../../models/meetings';

let lang = localStorage.getItem('I18N_LANGUAGE');
class AttendeesLists extends React.Component {
  constructor() {
    super();
    this.state = {
      officers: [],
      attendees: [],
      group: {},
      officers_loading: false,
      selected_location: false,
      saving_attendees: false,
    };
    this.handleAttendees = this.handleAttendees.bind(this);
  }

  componentDidMount() {
    this.loadOfficers();
  }

  handleCheckboxChange = (itemId) => {
    this.setState((prevState) => {
      const updatedOfficers = prevState.officers.map((item) =>
        item.id === itemId ? { ...item, isChecked: !item.isChecked } : item,
      );

      const selectedIds = updatedOfficers.filter((item) => item.isChecked).map((item) => item.id);

      const selectedOfficers = selectedIds.map((id) => {
        return {
          id: id,
        };
      });
      console.log(selectedIds);
      return {
        officers: updatedOfficers,
        selected_ids: selectedIds,
        selected_officers: selectedOfficers,
      };
    });
  };

  async loadOfficers() {
    this.setState({ officers_loading: true });
    const response = await getAllOfficers();
    if (response.success) {
      let officers = response.data;
      this.setState({ officers });
      this.setState({ officers_loading: false });
    }
  }

  async handleAttendees(event) {
    event.preventDefault();
    this.setState({ saving_attendees: true });
    try {
      let { selected_ids } = this.state;
      let payload = {
        attendees: selected_ids,
      };
      const response = await createMeetingAttendees(payload, this.props.id);
      if (response.success) {
        swal(i18n.t('success'), 'Attendees added to meeting successfully!!', 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((value) => {
            this.setState({ saving_attendees: false });
            this.props.onFinished();
          })
          .catch((response) => {
            swal('Failed', response.message, 'error');
          });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    let { officers_loading, officers, saving_attendees } = this.state;
    return (
      <>
        <MzadLoader animation="grow" size="md" loading={officers_loading} style={{ position: 'relative' }} />

        <div>
          <h5>
            {i18n.t('attendees')} {i18n.t('list')}
          </h5>
          <table className="table table-responsive">
            <thead>
              <tr>
                <th></th>
                <th>{i18n.t('sl_no')}</th>
                <th>{i18n.t('name')}</th>
                <th>{i18n.t('rank')}</th>
              </tr>
            </thead>
            <tbody>
              {officers.length > 0 &&
                officers.map((item, i) => {
                  return (
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          value={item.id}
                          checked={item.isChecked}
                          onChange={() => this.handleCheckboxChange(item.id)}
                          style={{ width: '1.2rem', height: '1.2rem' }}
                        />
                      </td>
                      <td>{i + 1}</td>
                      <td>{lang === 'ar' ? item?.name_ar : item?.name}</td>
                      <td>
                        {item.rank && item.rank_info
                          ? lang === 'ar'
                            ? item?.rank_info?.rank_ar
                            : item?.rank_info?.rank_en
                          : ''}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <button
            type="button"
            className="btn btn-primary btn-block mt-5"
            onClick={this.handleAttendees}
            disabled={saving_attendees}
          >
            {saving_attendees ? i18n.t('saving') : i18n.t('submit')}
          </button>
        </div>
      </>
    );
  }
}

export default AttendeesLists;
